var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_admin_attendanceModifiApp_list_title"),
      pad: "0",
    },
    on: { activated: _vm.activated },
    scopedSlots: _vm._u([
      {
        key: "page-main",
        fn: function () {
          return [
            _c("Taber", {
              attrs: {
                contentBackground: "transparent",
                curTab: _vm.curTab,
                special: "",
                items: _vm.taber,
              },
              on: {
                change: function (tab) {
                  return (_vm.curTab = tab)
                },
                filter: function (val, tab) {
                  if (tab == 1) {
                    _vm.filterPageData1 = val
                  } else {
                    _vm.filterPageData2 = val
                  }
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "filter-content-1",
                  fn: function (ref) {
                    var filter = ref.filter
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.curTab === "tab-1",
                              expression: "curTab === 'tab-1'",
                            },
                          ],
                        },
                        [
                          _c("Selections2", {
                            attrs: {
                              objects: _vm.filterObjects,
                              "small-chip": "",
                            },
                            on: {
                              filter: function ($event) {
                                filter()
                                _vm.toFilter(1, filter)
                              },
                              update: function (prop, value, selected) {
                                _vm.$fliterValue(
                                  _vm.filterObjects,
                                  prop,
                                  value,
                                  selected
                                )
                              },
                              reset: function (apply) {
                                _vm.$fliterValue(_vm.filterObjects, null, null)
                                if (apply) {
                                  filter()
                                  _vm.toFilter(1, filter)
                                }
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "filter-content-2",
                  fn: function (ref) {
                    var filter = ref.filter
                    return [
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.curTab === "tab-2",
                              expression: "curTab === 'tab-2'",
                            },
                          ],
                        },
                        [
                          _c("Selections2", {
                            attrs: {
                              objects: _vm.filterObjects2,
                              "small-chip": "",
                            },
                            on: {
                              filter: function ($event) {
                                filter()
                                _vm.toFilter(2, filter)
                              },
                              update: function (prop, value, selected) {
                                _vm.$fliterValue(
                                  _vm.filterObjects2,
                                  prop,
                                  value,
                                  selected
                                )
                              },
                              reset: function (apply) {
                                _vm.$fliterValue(_vm.filterObjects2, null, null)
                                if (apply) {
                                  filter()
                                  _vm.toFilter(2, filter)
                                }
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "content-1",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          headers: _vm.headers,
                          "filter-page-data": _vm.filterPageData1,
                          items: _vm.desserts,
                          showSelect: _vm.showSelect,
                          height: _vm.$vuetify.breakpoint.height - 335,
                          totalCount: _vm.totalCount1,
                        },
                        on: {
                          change: function (page, perpage, callback, data) {
                            _vm.getList(1, data, page, perpage, callback)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.applicant",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "max-width": "300px" } },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "pa-0 ma-0",
                                        attrs: { dense: "", "two-line": "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          {
                                            staticClass: "mr-1 my-0 pa-0",
                                            attrs: { size: "36" },
                                          },
                                          [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                size: "36",
                                                isTemp: item.is_temp,
                                                src: item.staff_avatar,
                                                staff_name: item.preferred_name,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      item.preferred_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary text-caption-xs",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.staff_code)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      item.job_post_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.record",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getDateTime(
                                            item.attendance_utc_date,
                                            "YYYY/MM/DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.date",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getDateTime(
                                            item.submission_utc_datetime,
                                            "YYYY/MM/DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.status",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("StatusChip", {
                                  attrs: {
                                    slideColor: item.approval_tint_color,
                                    bgColor: item.approval_bg_color,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "status",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.status_detail
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.hasBtn(
                                  "view-admin-attendance-modification-record"
                                )
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toView(item.uuid)
                                          },
                                        },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "currentColor",
                                            iconClass: "viewDetail",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
                {
                  key: "content-2",
                  fn: function () {
                    return [
                      _c("Tabler", {
                        attrs: {
                          "filter-page-data": _vm.filterPageData2,
                          headers: _vm.headers,
                          items: _vm.desserts2,
                          showSelect: _vm.showSelect,
                          height: _vm.$vuetify.breakpoint.height - 335,
                          totalCount: _vm.totalCount2,
                        },
                        on: {
                          change: function (page, perpage, callback, data) {
                            _vm.getList(2, data, page, perpage, callback)
                          },
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "item.applicant",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticStyle: { "max-width": "300px" } },
                                  [
                                    _c(
                                      "v-list-item",
                                      {
                                        staticClass: "pa-0 ma-0",
                                        attrs: { dense: "", "two-line": "" },
                                      },
                                      [
                                        _c(
                                          "v-list-item-avatar",
                                          {
                                            staticClass: "mr-1 my-0 pa-0",
                                            attrs: { size: "36" },
                                          },
                                          [
                                            _c("StaffAvatar", {
                                              attrs: {
                                                isTemp: item.is_temp,
                                                size: "36",
                                                src: item.staff_avatar,
                                                staff_name: item.preferred_name,
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "v-list-item-content",
                                          [
                                            _c("v-list-item-title", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      item.preferred_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "text--secondary text-caption-xs",
                                                },
                                                [
                                                  _vm._v(
                                                    " " +
                                                      _vm._s(item.staff_code)
                                                  ),
                                                ]
                                              ),
                                            ]),
                                            _c("v-list-item-subtitle", [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$getCommonLangValue(
                                                      item.job_post_name
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                            ]),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.record",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getDateTime(
                                            item.attendance_utc_date,
                                            "YYYY/MM/DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.date",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c(
                                  "div",
                                  { staticClass: "table-title text--primary" },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$getDateTime(
                                            item.submission_utc_datetime,
                                            "YYYY/MM/DD"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                              ]
                            },
                          },
                          {
                            key: "item.status",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _c("StatusChip", {
                                  attrs: {
                                    slideColor: item.approval_tint_color,
                                    bgColor: item.approval_bg_color,
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "status",
                                        fn: function () {
                                          return [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.status_detail
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                }),
                              ]
                            },
                          },
                          {
                            key: "item.action",
                            fn: function (ref) {
                              var item = ref.item
                              return [
                                _vm.hasBtn(
                                  "view-admin-attendance-modification-record"
                                )
                                  ? _c(
                                      "v-btn",
                                      {
                                        attrs: { icon: "", small: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toView(item.uuid)
                                          },
                                        },
                                      },
                                      [
                                        _c("svg-icon", {
                                          attrs: {
                                            size: "24",
                                            fill: "currentColor",
                                            iconClass: "viewDetail",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            },
                          },
                        ]),
                      }),
                    ]
                  },
                  proxy: true,
                },
              ]),
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }